export default "<div class=\"responsive\">\r\n  <CometChatUI></CometChatUI>\r\n</div>\r\n";